import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_SUPPLIERS_BASIC = "fetchSuppliersBasic";

//Mutations
export const SET_LOADING = "setLoadingSharedSupplier";

const state = {
  isLoadingSharedSupplier: false
};

const getters = {
  isLoadingSharedSupplier() {
    return state.isLoadingSharedSupplier;
  }
};

const actions = {
  [FETCH_SUPPLIERS_BASIC](context, apiParams = "") {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.get("suppliers-get-all-basic" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingSharedSupplier = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
